import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/types/content';

interface HeroSectionProps {
  featured: Article;
  sideList: Article[];
}

export default function HeroSection({ featured, sideList }: HeroSectionProps) {
  return (
    <section className="grid grid-cols-1 gap-6 lg:grid-cols-3" aria-label="本期头条">
      <div className="lg:col-span-2">
        <ArticleCard article={featured} variant="hero" />
      </div>

      <aside className="flex flex-col rounded-lg border border-background-300/70 bg-background-100 p-5">
        <div className="flex items-center justify-between border-b border-background-300/70 pb-3">
          <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <span className="flex h-4 w-4 items-center justify-center text-primary-600">
              <i className="ri-flashlight-line" />
            </span>
            即时速递
          </h2>
          <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-soft-pulse" />
            持续更新
          </span>
        </div>
        <div className="mt-4 flex flex-1 flex-col gap-4">
          {sideList.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="compact" />
          ))}
        </div>
      </aside>
    </section>
  );
}